import * as Actions from '../../../Modules/CmsActions'
import type { RootTerm } from '../../../Types'

const initialState: RootTerm[] = []

const TermReducer = (
  state: RootTerm[] = initialState,
  action,
): RootTerm[] | [] => {
  switch (action.type) {
    case Actions.SUCCESS_SHOW_POST_LIST:
    case Actions.SUCCESS_SHOW_POST_FORM:
    case Actions.FINISH_FIND_TERM:
      return setterms(action.payload)
    case Actions.LOGOUT:
      return initialState
    case Actions.UNLOAD_DEFAULT_RELATED_POST_CONDITIONS:
      return []

    default:
      return state
  }
}

const setterms = (payload) => {
  const taxonomies = payload.rootTerms.reduce((prev, term) => {
    prev[term.taxonomy_id] =
      prev[term.taxonomy_id] === undefined
        ? [term]
        : [...prev[term.taxonomy_id], term]
    return prev
  }, {})

  const terms = Object.keys(taxonomies).map((taxonomyId) => {
    const taxonomy = taxonomies[taxonomyId]

    const [parents, children] = taxonomy.reduce(
      (prev, term) => {
        const index = term.parent === null ? 0 : 1
        prev[index].push(term)
        return prev
      },
      [[], []],
    )

    return {
      taxonomy_id: Number(taxonomyId),
      terms: parents.map((parent) => {
        return {
          ...parent,
          children: children.filter((t) => t.parent === parent.id),
        }
      }),
    }
  })

  return terms
}

export default TermReducer
